import { GUEST } from 'constants/constants';
import useUser from 'hooks/user/useUser';
import requireValue from 'utils/requireValue';

const useHasRequiredRole = (role: string = GUEST) => {
  const [me] = useUser();
  if (!me) return false;
  const { roles = [] } = me;
  return requireValue(roles, 'includes').some((userRole) => userRole === role);
};

export default useHasRequiredRole;
